import { FC } from "react";
import styles from "./Card.module.css";
import { aspectRation } from "../../constants";
import { SaleItemDb } from "../../models/sale-item.db";
import { UserDb } from "../../models/user.db";
import { AppColors } from "../appColors";

interface PropTypes {
  onClick: (item: SaleItemDb) => void;
  item: SaleItemDb;
  indyxUser: UserDb | null;
  user: UserDb | null;
  width: number;
}

const Card: FC<PropTypes> = ({ onClick, item, user, indyxUser, width }) => {
  const brandName = item.brand ?? "";
  const size = item.size ?? "";
  const price = item.resaleValue ?? "";
  const itemPhotoURL = item.thumbnailImageUrl;
  const picUrl = user?.profilePhotoUrl;

  const color =
    item.reservedBy == null
      ? AppColors.background
      : item.reservedBy !== indyxUser?.id
      ? AppColors.sand
      : AppColors.lemon;

  const text =
    item.reservedBy == null
      ? "HOLD FOR PICKUP"
      : item.reservedBy !== indyxUser?.id
      ? "RESERVED"
      : "RESEVED FOR YOU";

  return (
    <div
      className={styles.card}
      onClick={() => {
        onClick(item);
      }}
      style={{ width: width }}
    >
      <div className={styles.cardBorder}>
        <div
          className={styles.itemPhoto}
          style={{
            width: width,
            height: width * aspectRation - 35,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img
            src={itemPhotoURL}
            alt=""
            style={{
              maxHeight: "95%",
              maxWidth: "95%",
              display: "block",
              margin: "auto",
            }}
          />
        </div>
        <div style={{ display: "flex", flexDirection: "row", padding: 10 }}>
          <div>
            <div
              style={{
                width: 30,
                height: 30,
                borderRadius: 30,
                backgroundImage: picUrl ? `url(${picUrl})` : undefined,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }}
            ></div>
          </div>

          <div
            style={{
              paddingLeft: 10,
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
              width: "75%",
            }}
          >
            <div
              style={{
                fontFamily: "Roobert",
                fontSize: 14,
                fontWeight: "bold",
                whiteSpace: "nowrap" /* запрет переноса строк */,
                overflow: "hidden" /* обрезает всё, что выходит за границы */,
                textOverflow: "ellipsis",
                textAlign: "left",
                width: "100%",
              }}
            >
              {brandName}
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "stretch",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <div
                style={{
                  fontFamily: "Spezia",
                  fontSize: 12,
                  whiteSpace: "nowrap" /* запрет переноса строк */,
                  overflow: "hidden" /* обрезает всё, что выходит за границы */,
                  textOverflow: "ellipsis",
                  textAlign: "left",
                  width: (width - 30 - 10 * 3) * (2 / 3),
                }}
              >
                Size {size}
              </div>
              <div
                style={{
                  fontFamily: "Spezia",
                  fontSize: 12,
                }}
              >
                ${price}
              </div>
            </div>
          </div>
        </div>

        <div className={styles.cardDescr} style={{ backgroundColor: color }}>
          <div
            className={styles.brandName}
            style={{
              textOverflow: "ellipsis",
              overflow: "hidden",
              whiteSpace: "nowrap",
            }}
          >
            {text}
          </div>
        </div>
      </div>
    </div>
  );
};
export default Card;
